import { render, staticRenderFns } from "./DsfPptPoster.vue?vue&type=template&id=1da0300c&"
import script from "./DsfPptPoster.vue?vue&type=script&lang=js&"
export * from "./DsfPptPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1da0300c')) {
      api.createRecord('1da0300c', component.options)
    } else {
      api.reload('1da0300c', component.options)
    }
    module.hot.accept("./DsfPptPoster.vue?vue&type=template&id=1da0300c&", function () {
      api.rerender('1da0300c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/control/DsfPptPoster.vue"
export default component.exports